import { RouteProps } from './types'

import * as Views from 'views'

export const routes: Array<RouteProps> = [
  {
    path: '/',
    exact: true,
    component: Views.Homepage.Index,
  },

  {
    path: '/cadastro',
    component: Views.Wizard.Index,
  },
]
